import { render, staticRenderFns } from "./program-module-subjects.vue?vue&type=template&id=da34e4da&scoped=true"
import script from "./program-module-subjects.vue?vue&type=script&lang=js"
export * from "./program-module-subjects.vue?vue&type=script&lang=js"
import style0 from "./program-module-subjects.vue?vue&type=style&index=0&id=da34e4da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da34e4da",
  null
  
)

export default component.exports